const ru = {
	login: 'Авторизоваться',
	logout: 'Выйти',
	signin: 'войти в систему',
	signup: 'зарегистрироваться',
	email: 'Эл. адрес',
	emailAddr: 'Адрес электронной почты',
	password: 'пароль',
	rememberMe: 'Запомнить меня',
	forgotYourPwd: 'Забыли свой пароль?',
	signinFacebook: 'Авторизоваться с помощью Фэйсбука',
	signinGoogle: 'Войти через Google',
	dontAccount: 'У вас нет аккаунта?',
	firstName: 'Имя',
	lastName: 'Фамилия',
	confirmPwd: 'Подтвердите пароль',
	signup_msg: 'Нажимая кнопку «Присоединиться сейчас», вы соглашаетесь с',
	digitX_user_agreement: 'DigitXchange Пользовательское соглашение',
	privacy_policy: 'политика конфиденциальности',
	and: ' и ',
	cookies_policy: 'Политика в отношении файлов cookie',
	have_account: 'Уже есть аккаунт',
	forgotPwd: 'Забыть пароль',
	recoverPwd: 'ВОССТАНОВИТЬ ПАРОЛЬ',
	forgotPwd_msg: 'Поместите свой адрес электронной почты в поле выше, мы вышлем вам ссылку с инструкциями для подражания.',
	changePwd: 'Сменить пароль',
	oldPwd: 'Прежний пароль',
	newPwd: 'Новый пароль',
	confirmNewPwd: 'Подтвердите новый пароль',
	user_account: 'Учетная запись пользователя',
	change_pic: 'Изменить картинку',
	mobile_number: 'Мобильный номер',
	country: 'Страна',
	update_settings: 'обновить настройки',
	company: 'Компания',
	aboutUs: 'Насчет нас',
	tos: 'TOS',
	copyright: 'Авторские права',
	socialMedia: 'Социальные медиа',
	forUpdates: 'для обновлений',
	footer_msg_1: 'Регистрируясь, вы принимаете',
	terms: 'условия обслуживания',
	contactUs: 'Связаться с нами',
	yourEmail: 'Ваш адрес электронной почты',
	required: 'обязательный',
	yourMsg: 'Ваше сообщение',
	sent: 'Отправлено',
	footer_msg_2: 'Все права защищены',
	footer_msg_3: 'Все названия продуктов, торговые марки и зарегистрированные торговые марки являются собственностью их соответствующих владельцев.',
	doom: 'Doom III',
	filter: 'Фильтр',
	add_asset: 'Добавить актив',
	request_game: 'Запросить игру',
	search_msg: 'Извините, но ничего не соответствует вашим условиям поиска.',
	post: 'Почта',
	asset: 'Актив',
	create: 'Создайте',
	character: 'символ',
	characters: 'Персонажи',
	assets: 'активы',
	profile: 'Профиль',
	game: 'Игра',
	games: 'Игры',
	currency: 'валюта',
	store: 'хранить',
	all_time: 'Все время',
	this_month: 'Этот месяц',
	trending: 'Trending',
	item_name: 'Имя элемента',
	view_item: 'Посмотреть объект',
	leaderboard: 'Leaderboard',
	posters: 'Плакаты',
	chinese: 'китайский язык',
	english: 'английский',
	japanese: 'японский язык',
	korean: 'корейский язык',
	german: 'Немецкий',
	french: 'Французский',
	spanish: 'испанский',
	italian: 'итальянский',
	russian: 'русский',
	portuguese: 'португальский',
	hindi: 'хинди',
	arabic: 'арабский',
	buy: 'купить',
	subscription: 'Подписка',
	buy_subscription: 'Купить подписку',
	gift: 'Подарок',
	xchange: 'Xchange',
	subscription_plan: 'План подписки',
	payment_options: 'Варианты оплаты',
	cardholder_name: 'Имя владельца карты',
	submit_order: 'Подтвердить заказ',
	card_number: 'Номер карты',
	cvv: 'CVV',
	expiration_date: 'Дата окончания срока',
	buyXchange: 'Купить Xchange',
	giftXchange: 'Подарочный обмен',
	or: 'или',
	select: 'Выбрать',

	search: 'Поиск',
	search_games: 'Поиск игр ...',
	search_assets: 'Поиск активов ...',
	platform: 'Платформа',
	total_posts: 'Всего сообщений',
	total_comments: 'Всего комментариев',
	total_characters: 'Всего персонажей',
	total_assets: 'Всего активов',
	xchange_currency: 'Обмен валюты',
	subscription_days_remaining: 'Осталось дней подписки',
	total_asset_networth: 'Всего активов Networth',
	total_character_networth: 'Тотальный Персонаж Нетворс',
	most_downloaded: 'Самые скачиваемые',
	recently_added: 'Недавно добавленный',
	genre: 'Жанр',
	my_library: 'Моя библиотека',
	most_commented: 'Самые комментируемые',
	most_recent: 'Самые последние',
	nearing_addition: 'Близкое дополнение',
	create_asset: 'Создать актив',
	create_character: 'Создать персонажа',
	asset_name: 'Название актива',
	asset_type: 'Тип актива',
	rarity: 'раритет',
	enhancements: 'Улучшения',
	add: 'Добавить',
	currency_type: 'Тип валюты',
	price: 'Цена',
	description: 'Описание',
	upload_asset: 'Загрузить актив',
	preview_asset: 'Предварительный просмотр актива',
	main_image: 'Основное изображение',
	upload_video: 'Загрузить видео',
	upload: 'Загрузить',
	view_demo: 'Посмотреть демо',
	character_name: 'Название характера',
	character_type: 'Тип персонажа',
	upload_character: 'Загрузить персонаж',
	preview_character: 'Предварительный просмотр персонажа',
	race: 'раса',
	class: 'Учебный класс',
	gender: 'Пол',
	level: 'уровень',
	showing: 'показ',
	of: 'из',
	results: 'Результаты',
	featured_characters: 'Избранные персонажи',
	url: 'URL',
	submit: 'Разместить',
	real_world: 'Реальный мир',
	game_currency: 'Игровая валюта',
	all: 'Все',

	edit: 'редактировать',
	save: 'Сохранить',
	agg_character_networth: 'Агрегированный характер Networth',
	agg_time_played: 'Общее время игры',
	agg_asset_value: 'Совокупная стоимость активов',
	enter_character_creation_date: 'Введите дату создания персонажа',
	in_game_currency: 'В игровой валюте',
	real_world_value: 'Ценность реального мира',
	update_character: 'Обновить персонажа',
	item_not_found: 'Предмет не найден!',
	ripper: 'риппер',
	comments: 'Комментарии',
	add_comments: 'Добавить комментарии',
	new_suggested_price: 'Новая предложенная цена',
	sort_by: 'Сортировать по',
	reply: 'Ответить',
	asset_networth: 'Актив Нетворт',
	join_date: 'Дате вступления',
	report: 'отчет',
	first: 'Первый',
	last: 'Последний',
	most_replies: 'Большинство Ответов',
	new_pricing_recommendations: 'Новые ценовые рекомендации',
	xchange_amount: 'Сумма Xchange',
	username: 'имя пользователя',
	send_gift: 'Послать подарок',
	message: 'Сообщение',
	gift_text: 'Персонализируйте ваше сообщение здесь',
	day: 'день',
	days: 'дней',
	currency_converter: 'Конвертер валют',
	from: 'Из',
	to: 'к',
	in_game: 'В игре',
	real_life: 'Реальная жизнь',
	cvc: 'CVC',
	card: 'Открытка',
	per_month: 'Ежемесячно (3 доллара в месяц)',
	per_year: 'Ежегодно (30 долларов США в год)',
	aboutUs_text: 'DigitXChange - это управляемый сообществом веб-сайт, целью которого является окончательная оценка стоимости цифровых товаров и услуг с помощью краудсорсинга. Если вы когда-либо задавали вопрос «сколько на самом деле стоит мой персонаж» или «мне интересно, какова будет справедливая сделка с другим игроком в другой игре», не ищите дальнейших ответов. Мы надеемся, что вам понравится наш сайт, вы участвуете в создании групповых знаний, демонстрируете свой с трудом заработанный лут и в конечном итоге с нетерпением ждете, чтобы узнать ваш общий цифровой собственный капитал!',
	home: 'домашняя страница',
	all_time_characters: 'Все время персонажи',
	this_month_characters: 'Персонажи этого месяца',
	trending_characters: 'Тенденции персонажей',
	all_time_posters: 'Все время Плакаты',
	this_month_posters: 'Плакаты этого месяца',
	trending_posters: 'Тенденции Плакаты',
	
};

export default ru;


// WEBPACK FOOTER //
// ./src/translations/ru.js